import * as Yup from 'yup';

export const productSchema = Yup.object({
	title: Yup.string().required('Title is required'),
	bodyHtml: Yup.string().required('Description is required'),
	productInfo: Yup.string().nullable(),
	vendor: Yup.string(),
	type: Yup.string().required('Type is required'),
	tags: Yup.string(),
	published: Yup.boolean(),
	imageSrc: Yup.string().url('Must be a valid URL'),
});
